import React, { useState } from 'react'

import { Tooltip } from '@material-ui/core'
import {
  CheckBox,
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  ModalJustify,
  Row,
  ModalObservacao
} from 'components'
import {
  DeleteIcon,
  InfoIcon,
  StatusIcon,
  UploadIcon,
  ViewFileIcon
} from 'components/Icons'
import { useToggle, useFile, useModal } from 'hooks'
import moment from 'moment'
import { Anexo } from 'services/Supplier/ThirdPartyAdministration'
import { COLORS, SPACING } from 'utils'
import useHandleViewFile from 'pages/Supplier/AttachDocuments/ThirdPartyAdministration/context'

interface ITableMonthlyDocumentation {
  tableData: Anexo[]
  handleJustify: (_txt: string, _context: Anexo) => void
  handleSelectAll?: (
    _cdContrato: string,
    _e: React.ChangeEvent<HTMLInputElement>
  ) => void
  handleUpdateCheckBox?: (_cdContrato: string, _tipo: string) => void
  handleDelete?: (_id?: number) => void
  handleDeleteDocument?: (_id?: number) => void
  handleUploadFile?: (_data: {
    file: File
    idMovDocumentoForAdd: number
  }) => void
}

export const TableMonthlyDocumentation: React.FC<ITableMonthlyDocumentation> =
  ({ tableData, handleJustify, handleDeleteDocument, handleUploadFile }) => {
    const { showModal: showSystemModal } = useModal()
    const { handleViewFile } = useHandleViewFile()
    const [showModal, toggleModal] = useToggle(false)
    const [showObservaco, toggleObservacaoModal] = useToggle()
    const [txObservacao, setTxObservacao] = useState<string>('')
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(15)
    const [selectedJustifyDoc, setSelectedJustifyDoc] = useState<
      Anexo | undefined
    >()
    const [justificativa, setJustificativa] = useState<string>('')

    const handleChangePage = (newPage: number) => setPage(newPage)

    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      setRowsPerPage(parseInt(event.target.value, 10))
      setPage(0)
    }

    const openFileChoose = (idMovDocumento: number) => {
      document.getElementById(`file-upload-${idMovDocumento}`).click()
    }

    const setStatusColor = (cdStatus?: string): string => {
      if (!['Analisar', 'Aprovado', 'Recusado'].includes(cdStatus)) {
        return COLORS.gray
      }
      switch (cdStatus) {
        case 'Aprovado':
          return COLORS.success
        case 'Recusado':
          return COLORS.error
        case 'Analisar':
          return COLORS.alert
        default:
          return COLORS.gray
      }
    }

    const onChooseFileToUpload = (
      event: React.ChangeEvent<HTMLInputElement>,
      idMovDocumento: number
    ) => {
      if (event.target.files[0]) {
        if (event.target.files[0].type.includes('pdf')) {
          const limitUpload = 2000000000 // 2GB

          if (event?.target?.files[0].size >= limitUpload) {
            showSystemModal({
              type: 'alert',
              message: 'Limite para o tamanho do arquivo atingido: 2GB portanto arquivo não pode ser anexado',
              hideButtonCancel: true,
              txtButtonConfirm: 'OK'
            })

            return
          }

          handleUploadFile({
            file: event.target.files[0],
            idMovDocumentoForAdd: idMovDocumento
          })

          event.target.value = ''
          return
        }

        showSystemModal({
          hideButtonCancel: true,
          message: 'Só é permitido anexar documentos em PDF.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      }
    }

    const handleStatus = (status: string) => {
      if (
        status === 'Green' ||
        status === 'Aprovado' ||
        status === 'Liberado' ||
        status === 'L'
      )
        return 'Aprovado'
      if (
        status === 'Yellow' ||
        status === 'Analisar' ||
        status === 'Analisando' ||
        status === 'PendenteDocumento' ||
        status === 'P'
      )
        return 'Em análise'
      if (status === 'Red' || status === 'Recusado' || status === 'B')
        return 'Reprovado'
      return 'Pendente envio'
    }

    return (
      <>
        <TableContainerStyled>
          <TableStyled>
            <TableHeadStyled>
              <TableRowStyled>
                <TableCellStyled padding="checkbox" align="center">
                  {/* <CheckBox marginRight="auto" marginLeft="auto" /> */}
                </TableCellStyled>
                <TableCellStyled>Tipo Documento</TableCellStyled>
                <TableCellStyled align="center">Data Anexada</TableCellStyled>
                <TableCellStyled>Descrição</TableCellStyled>
                <TableCellStyled align="center" padding="checkbox">
                  Justificativa
                </TableCellStyled>
                <TableCellStyled align="center">
                  Retorno Analise
                </TableCellStyled>
                <TableCellStyled align="center">
                  Observação da Analise
                </TableCellStyled>
                <TableCellStyled align="center" padding="checkbox">
                  Status
                </TableCellStyled>
                <TableCellStyled align="center">Ações</TableCellStyled>
              </TableRowStyled>
            </TableHeadStyled>
            <TableBodyStyled>
              {(rowsPerPage > 0
                ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
                : tableData
              )?.map((row) => (
                <TableRowStyled key={`table-item-${row?.idMovDocumento}`}>
                  <TableCellStyled padding="checkbox" align="center">
                    <CheckBox
                      marginRight="auto"
                      marginLeft="auto"
                      checked={Boolean(row?.base64)}
                      disabled={['Analisar', 'Aprovado'].includes(
                        row?.cdStatus
                      )}
                    />
                  </TableCellStyled>
                  <TableCellStyled>
                    {row?.txDescricaoTipo || '- - - - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.dtAnexado
                      ? moment(row?.dtAnexado).format('DD/MM/YYYY')
                      : '- - - - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row?.txDescricaoAnexo || '- - - - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <InfoIcon
                      onClick={() => {
                        toggleModal()
                        setSelectedJustifyDoc(row)
                        setJustificativa(row?.txJustificativa)
                      }}
                      cursor="pointer"
                    />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.dtRetorno
                      ? moment(row?.dtRetorno).format('DD/MM/YYYY')
                      : '- - - - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <InfoIcon
                      disabled={row?.dtRetorno === null}
                      onClick={() => {
                        setTxObservacao(row?.txObservacaoAnexo)
                        toggleObservacaoModal()
                      }}
                      cursor="pointer"
                    />
                  </TableCellStyled>
                  <Tooltip
                    arrow
                    title={handleStatus(row?.cdStatus)}
                    placement="left"
                  >
                    <TableCellStyled align="center" padding="checkbox">
                      <StatusIcon
                        value={row?.cdStatus}
                        colorIcon={setStatusColor(row?.cdStatus)}
                        marginLeft="auto"
                        marginRight="auto"
                      />
                    </TableCellStyled>
                  </Tooltip>
                  <TableCellStyled align="center">
                    <Row alignItems="center" justifyContent="flex-start">
                      <input
                        type="file"
                        accept="application/pdf"
                        onChange={(event) =>
                          onChooseFileToUpload(event, row?.idMovDocumento)
                        }
                        id={`file-upload-${row?.idMovDocumento}`}
                        style={{ display: 'none' }}
                      />
                      <UploadIcon
                        key={row.idMovDocumento}
                        onClick={() => openFileChoose(row?.idMovDocumento)}
                        colorIcon={COLORS.black}
                        cursor="pointer"
                        disabled={
                          ['Analisar', 'Aprovado'].includes(row?.cdStatus) ||
                          Boolean(row?.base64)
                        }
                      />
                      <ViewFileIcon
                        onClick={() =>
                          handleViewFile({
                            gedExternalID: row?.cdGedExternalId,
                            local: {
                              base64: row.base64,
                              filename: row.filename
                            }
                          })
                        }
                        marginLeft={SPACING.spacing15}
                        marginRight={SPACING.spacing15}
                        cursor="pointer"
                        disabled={
                          ['Pendente', null].includes(row?.cdStatus) &&
                          !row?.base64
                        }
                        colorIcon={COLORS.black}
                      />
                      <DeleteIcon
                        onClick={() =>
                          handleDeleteDocument(row?.idMovDocumento)
                        }
                        disabled={['Aprovado'].includes(row?.cdStatus) || !row?.base64}
                        cursor="pointer"
                      />
                    </Row>
                  </TableCellStyled>
                </TableRowStyled>
              ))}
            </TableBodyStyled>
          </TableStyled>
        </TableContainerStyled>
        <TableFooter
          page={page}
          rows={tableData || []}
          typeFooter="offline"
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
        <ModalObservacao
          showModal={showObservaco}
          toggleModal={toggleObservacaoModal}
          txObservacao={txObservacao}
        />
        {['Aprovado', 'Analisar'].includes(selectedJustifyDoc?.cdStatus) ? (
          <ModalJustify
            showModal={showModal}
            toggleModal={toggleModal}
            defaultValue={selectedJustifyDoc?.txJustificativa}
            txJustificativa={selectedJustifyDoc?.txJustificativa}
            viewMode
          />
        ) : (
          <ModalJustify
            showModal={showModal}
            cdStatus={selectedJustifyDoc?.cdStatus}
            defaultValue={selectedJustifyDoc?.txJustificativa}
            value={justificativa}
            onChangeText={setJustificativa}
            toggleModal={toggleModal}
            handleJustify={() =>
              handleJustify(justificativa, selectedJustifyDoc)
            }
          />
        )}
      </>
    )
  }
